import moment from "moment";

export default function CopyRight() {
	return (
		<section>
			<span>givatake</span>
			<span> {moment().format("YYYY")}©</span>
		</section>
	);
}
